module.exports = __webpack_public_path__ + "media/images/f_bg-a2181dbbb0bbd47c8096d0ff3b24aeae.png";